<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <button type="button" class="btn btn btn-outline-light btn-sm" @click="changeLanguage('es')">Espa&ntilde;ol</button>
    <button type="button" class="btn btn btn-outline-light btn-sm" @click="changeLanguage('en')">Ingl&eacute;s</button>
    <button type="button" class="btn btn btn-outline-light btn-sm" @click="changeLanguage('na')">Lengua de señas mexicana</button>
    <h2>VIDEO INTRODUCTORIO</h2>
    <!-- <video autoplay width="100%" controls disablePictureInPicture controlsList="nodownload noremoteplayback" src="galerias/lobby/tenochtitlan.mp4"/> -->
    <!-- <Youtube width="100%" :video-id="videoId" :player-vars="playerVars" @playing="playing"/> -->
    <Youtube v-if="language=='es'" width="100%" :video-id="videoIdES" :player-vars="playerVars" @playing="playing"/>
    <Youtube v-if="language=='en'" width="100%" :video-id="videoIdEN" :player-vars="playerVars" @playing="playing"/>
    <Youtube v-if="language=='na'" width="100%" :video-id="videoIdLSM" :player-vars="playerVars" @playing="playing"/>
  </div>
</template>

<script>

import { Youtube } from "vue-youtube";

export default {
  name: "video-sala3_1",
  data() {
    return {
      videoIdES: "UJOjakTz_w8",
      videoIdEN: "Gk0ckLiTNe8",
      videoIdLSM: "JZq0B1gp_Vk",
      playerVars: {
        autoplay: 1
      },
      language: "es"
    };
  },
  methods: {
    playing() {
      // console.log("we are watching!!!");
    },
    changeLanguage(lan) {
      this.language = lan;
    }
  },
  components: {
    Youtube
  },
  props: {},
  mounted() {},
};
</script>
